import React from 'react';
import { DollarSign, CreditCard, Tag, TrendingUp, Settings, Plus } from 'lucide-react';

const MonetizationPanel = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Monetización</h1>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-accent hover:bg-accent/90">
          <Plus className="h-4 w-4 mr-2" />
          Nueva Promoción
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">Ingresos Totales</p>
              <h3 className="text-2xl font-bold text-foreground">€45,678</h3>
            </div>
            <DollarSign className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500">+23.7% vs mes anterior</span>
            </div>
          </div>
        </div>

        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">ARPU</p>
              <h3 className="text-2xl font-bold text-foreground">€39.99</h3>
            </div>
            <CreditCard className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500">+12.3% vs mes anterior</span>
            </div>
          </div>
        </div>

        <div className="dark-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-foreground/70">Tasa de Conversión</p>
              <h3 className="text-2xl font-bold text-foreground">12.4%</h3>
            </div>
            <Tag className="h-8 w-8 text-accent" />
          </div>
          <div className="mt-4">
            <div className="flex items-center">
              <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
              <span className="text-sm text-green-500">+5.2% vs mes anterior</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="dark-card p-6">
          <h2 className="text-lg font-medium text-foreground mb-4">Planes de Suscripción</h2>
          <div className="space-y-4">
            {[
              { name: 'Plan Free', price: '€0', users: 2345, revenue: '€0' },
              { name: 'Plan Pro', price: '€49.99', users: 1234, revenue: '€61,687' },
              { name: 'Plan Premium', price: '€99.99', users: 567, revenue: '€56,693' }
            ].map((plan, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-secondary/30 rounded-lg">
                <div>
                  <h3 className="text-sm font-medium text-foreground">{plan.name}</h3>
                  <p className="text-sm text-foreground/70">{plan.price}/mes</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-foreground">{plan.users} usuarios</p>
                  <p className="text-sm text-foreground/70">{plan.revenue}</p>
                </div>
              </div>
            ))}
            <button className="w-full flex items-center justify-center px-4 py-2 border border-border rounded-md text-sm font-medium text-foreground hover:bg-secondary/30">
              <Settings className="h-4 w-4 mr-2" />
              Gestionar Planes
            </button>
          </div>
        </div>

        <div className="dark-card p-6">
          <h2 className="text-lg font-medium text-foreground mb-4">Promociones Activas</h2>
          <div className="space-y-4">
            {[
              { name: 'Descuento Primavera', discount: '20%', ends: '15/06/2025', uses: 234 },
              { name: 'Plan Anual', discount: '30%', ends: '31/12/2025', uses: 567 },
              { name: 'Primera Compra', discount: '15%', ends: 'Sin fin', uses: 890 }
            ].map((promo, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-secondary/30 rounded-lg">
                <div>
                  <h3 className="text-sm font-medium text-foreground">{promo.name}</h3>
                  <p className="text-sm text-foreground/70">Descuento: {promo.discount}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-foreground">Finaliza: {promo.ends}</p>
                  <p className="text-sm text-foreground/70">{promo.uses} usos</p>
                </div>
              </div>
            ))}
            <button className="w-full flex items-center justify-center px-4 py-2 border border-border rounded-md text-sm font-medium text-foreground hover:bg-secondary/30">
              <Plus className="h-4 w-4 mr-2" />
              Crear Nueva Promoción
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonetizationPanel;